import type { ComponentType } from 'react'
import Soccer from './Soccer'
import Baseball from './Baseball'
import Basketball from './Basketball'
import Football from './Football'
import Golf from './Golf'
import Lacrosse from './Lacrosse'
import Skiing from './Skiing'
import Swimming from './Swimming'
import Tennis from './Tennis'
import Volleyball from './Volleyball'
import TeamSportGroup from './TeamSportGroup'
import IndividualSportGroup from './IndividualSportGroup'
import SeasonalSportGroup from './SeasonalSportGroup'

type IllustrationComponent = ComponentType<{ className?: string }>

/**
 * Sport slug → hero/card illustration component.
 * Sports without an entry simply render no illustration.
 */
export const SPORT_ILLUSTRATIONS: Record<string, IllustrationComponent> = {
  soccer: Soccer,
  baseball: Baseball,
  basketball: Basketball,
  'flag-football': Football,
  golf: Golf,
  lacrosse: Lacrosse,
  'lacrosse-boys': Lacrosse,
  'lacrosse-girls': Lacrosse,
  skiing: Skiing,
  swimming: Swimming,
  tennis: Tennis,
  volleyball: Volleyball,
}

/** City hub interest-group section illustrations (team / individual / seasonal). */
export const CITY_GROUP_ILLUSTRATIONS = {
  team: TeamSportGroup,
  individual: IndividualSportGroup,
  seasonal: SeasonalSportGroup,
} as const satisfies Record<string, IllustrationComponent>
